import Component from '../core/Component'
import { query } from '../utils/dom'
import SectionObserver, { EMITS as SECTIONOBSERVER_EMITS } from './SectionObserver'
import enquire from 'enquire.js'

export default class SectionNav extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            links: [],
            sectionObserver: null
        }

        this.ref.sectionObserver = query(this.options.sectionObserverQuery)

        this.index = null
        this.enquireHandler = {
            match: () => this.attach(),
            unmatch: () => this.detach()
        }
    }

    prepare() {
        enquire.register('screen and (min-width: 100em)', this.enquireHandler)
    }

    destroy() {
        enquire.unregister('screen and (min-width: 100em)', this.enquireHandlers)
        if (this.sectionObserver) {
            this.sectionObserver.destroy()
        }
    }

    attach() {
        if (this.ref.sectionObserver) {
            this.sectionObserver = new SectionObserver(this.ref.sectionObserver)
            this.sectionObserver.on(SECTIONOBSERVER_EMITS.SECTION_CHANGE, this.handleSectionChange)
            this.sectionObserver.prepare()
        }
    }

    detach() {
        this.sectionObserver.destroy()
    }

    handleSectionChange = data => {
        const index = data.index

        this.select(index)
    }

    select(index) {
        if (this.index === index) {
            return
        }

        this.index = index

        let isLinkActive = true
        this.ref.links.forEach(link => {
            if (isLinkActive) {
                link.parentNode.classList.add('is-active')
                link.parentNode.classList.remove('is-active-last')
            } else {
                link.parentNode.classList.remove('is-active-last')
                link.parentNode.classList.remove('is-active')
            }

            if (this.ref.links[index] === link) {
                link.parentNode.classList.add('is-active-last')
                isLinkActive = false
            }
        })
    }
}